import type { ReactNode } from 'react'
import * as Progress from '@radix-ui/react-progress'

import { cn } from '../lib/utils'

interface ProgressBarProps {
    progress: number
    children?: ReactNode
    className?: string
}

export const ProgressBar = ({ children, className, progress = 0 }: ProgressBarProps) => {
    return (
        <Progress.Root
            max={100}
            className={cn(
                'overflow-hidden bg-transparent rounded-full h-1 translate-z-0',
                className,
            )}
            aria-label={`${progress}%`}
        >
            <Progress.Indicator
                className="bg-lp-peach1 w-full h-full transition-transform duration-[1200ms] cubic-bezier(0.65, 0, 0.35, 1)"
                style={{ transform: `translateX(-${100 - progress}%)` }}
            />
            {children}
        </Progress.Root>
    )
}
